module.exports = __webpack_public_path__ + "img/227.3e965d91.jpg";